import { TimeRange } from '../query/query.types';

// eslint-disable-next-line import/no-mutable-exports
export let BOARD_LABEL = 'Observation Deck';

export interface Variable {
  enabled?: boolean;
  type?: 'guided' | 'custom';
  name: string;
  value: string | string[] | null;
  options?: { value: string; label?: string }[];
  allowMulti?: boolean;
  exactMatch?: boolean;
  operator?: string;
}

export interface BoardData {
  id: number;
  company_id: string;
  user_id: string;
  title: string;
  config: {
    presetFilters?: unknown[];
    layoutMode?: string;
    // explicitly convert to dashboard, even if there's only one panel
    isDashboard?: boolean;
    time?: TimeRange;
    timezone?: string;
    updateFrequency?: number;
    [key: string]: unknown;
    variables?: Variable[];
  };
  share_level: 'self' | 'org';
  type: string | null;
  draft: boolean;
  cdate: Date;
  edate: Date;
}

export function setBoardLabel(label: string) {
  BOARD_LABEL = label;
}
